import { SxProps } from "@mui/material";

export const sxTitle: SxProps = {
  fontFamily: "UnimedSans-Bold",
  fontSize: "24px !important",
  lineHeight: "30px",
  letterSpacing: "0em",
  textAlign: "left",
  color: '#383838 !important',
}

export const sxSubTitle: SxProps = {
  fontFamily: "UnimedSans-Bold",
  fontSize: "16px",
  lineHeight: "24px",
  letterSpacing: "0em",
  textAlign: "left",
  color: '#383838',
}

export const sxTableTitle: SxProps = {
  fontFamily: "Unimed-Sans",
  fontSize: "16px",
  lineHeight: "24px",
  letterSpacing: "0em",
  textAlign: "left",
  textWrap: "nowrap",
  fontWeight: 700
}

export const sxSubTitleSmall: SxProps = {
  fontFamily: "UnimedSans-Bold",
  fontSize: "16px",
  lineHeight: "12px",
  letterSpacing: "0em",
  textAlign: "left",
  color: '#4C4C4C',
}

export const sxInput: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#383838',
  fontWeight: 400,
  maxWidth: '485px',
  fontSize: '14px'
}

export const sxGreenSubTitle: SxProps = {
  fontFamily: "UnimedSans-Bold",
  fontSize: "16px",
  lineHeight: "24px",
  letterSpacing: "0em",
  textAlign: "left",
  color: '#00995d',
}

export const sxGreenTitle: SxProps = {
  fontFamily: "UnimedSans-Bold",
  fontSize: "20px",
  lineHeight: "24px",
  letterSpacing: "0em",
  textAlign: "left",
  color: '#00995d',
}

export const sxGreenBody: SxProps = {
  fontFamily: "Unimed-Sans",
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: "0em",
  textTransform: "none",
  color: "#00995d"
}

export const sxWhiteTextButton: SxProps = {
  fontFamily: 'Unimed-Sans',
  textTransform: 'none',
  fontWeight: 700,
  padding: '4px',
  fontSize: '16px',
  color: '#ffffff'
}

export const sxGreenTextButton: SxProps = {
  fontFamily: 'Unimed-Sans',
  textTransform: 'none',
  fontWeight: 700,
  padding: '4px',
  fontSize: '16px',
  color: '#00995D',
  cursor: 'pointer'
}

export const sxDarkGreyBody: SxProps = {
  fontFamily: "Unimed-Sans",
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: "0em",
  textAlign: "left",
  color: '#4C4C4C',
}

export const sxMenuItem: SxProps = {
  fontFamily: 'Unimed-Sans', 
  fontSize: '14px', 
  textWrap: 'pretty',
  padding: '12px', 
  margin: '0px',
}

export const sxButton: SxProps = {
  borderRadius: '80px',
  height: '44px',
  padding: '24px 32px'
}

export const sxFormError: SxProps = {
  color: '#D84141',
  fontSize: '12px'
}

export const sxLabel: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#383838',
  fontWeight: 600,
}

export const sxCircularProgressCenter: SxProps = {
  display: 'flex', 
  flexDirection: 'column', 
  alignSelf: 'center'
}

export const sxDivider: SxProps = {
  width: '100%',
  height: '1px',
  fill: 'none',
  backgroundColor: '#a5a5a5',
  opacity: '0.4'
}

export const sxCheckbox: SxProps = {
  '.MuiFormControlLabel-label': {
    fontSize: '14px',
    color: '#4C4C4C',
    fontFamily: 'Unimed-Sans'
  }
}

export const sxCheckboxContrast: SxProps = {
  '.MuiFormControlLabel-label': {
    fontSize: '14px',
    color: 'white',
    fontFamily: 'Unimed-Sans'
  }
}

export const sxLabeledOutlinedInput: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  '@media (max-width: 768px)': {
    width: '100%'
  }
}

export const sxOutlinedInput: SxProps = {
  fontFamily: 'Unimed-Sans',
  fontWeight: 400,
  fontSize: '16px',
  '@media (max-width: 768px)': {
    minWidth: 'unset'
  }
}

export const sxTableOverflow: SxProps = {
  borderRadius: '10px',
  width: '100%',
  '@media (max-width: 1135px)': {
      width: '60vw'
  },
  '@media (max-width: 1055px)': {
      width: '55vw'
  },
  '@media (max-width: 920px)': {
      width: '50vw'
  },
  '@media (max-width: 899px)': {
      width: '90vw'
  },
  '@media (max-width: 425px)': {
      width: '85vw'
  }
}

export const sxPagination: SxProps = {
	width: 'auto',
	height: '32px',
	background: 'unset',
	color: 'unset',
	fontSize: 'unset',
	fontStyle: 'unset',
	fontWeight: 'unset',
	lineHeight: 'unset',
	position: 'unset',
	button: {
			fontFamily: 'UnimedSans-Bold',
			backgroundColor: '#EEE',
			color: '#5F5F5F'
	}
}

export const sxPaginationContrast: SxProps = {
	...sxPagination,
	'& .MuiPaginationItem-root': {
    backgroundColor: 'black',
    color: '#FFFF00',
    border: '1px solid white'
  },
	'& .MuiPaginationItem-page.Mui-selected': {
		backgroundColor: '#FFFF00',
		color: 'black',
	},
	'& .MuiPaginationItem-page:hover': {
		backgroundColor: 'lightyellow', // Background color for the hovered page
	},
}

export const sxMessageTextField: SxProps = {
  boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.08)',
  "& .MuiOutlinedInput-root": {
    alignItems: 'flex-start',
    height: 'unset',
    minHeight: '150px',
    fontFamily: 'Unimed-Sans',
  },
  "& .MuiOutlinedInput-input": {
    fontFamily: 'Unimed-Sans',
    color: '#383838',
    fontSize: '14px',
  },
}

export const sxMessageTextFieldContrast: SxProps = {
  "& .MuiOutlinedInput-root": {
    alignItems: 'flex-start',
    height: 'unset',
    minHeight: '150px',
    fontFamily: 'Unimed-Sans',
    backgroundColor: 'black',
  },
  "& .MuiOutlinedInput-input": {
    fontFamily: 'Unimed-Sans',
    color: 'white',
    fontSize: '14px',
    borderColor: 'white',
  },
}

export const sxContatoAviso: SxProps = {
  marginTop: '10px',
  color: '#CC3D3D',
  fontSize: '12px',
  fontStyle: 'italic',
  lineHeight: '18px',
  maxWidth: '485px',
}